import HttpStatus from 'redpoints-connector-common/enumeration/HttpStatus';

import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  ALL_INCIDENTS_CLEAR,
  ALL_INCIDENTS_TABLE_EXPORT_PIRACY_PERMISSION,
} from '../../../../actions/actionTypes';

const tableExportPiracyPermission = fetchReducerGenerator(
  ALL_INCIDENTS_CLEAR,
  ALL_INCIDENTS_TABLE_EXPORT_PIRACY_PERMISSION
);

export default tableExportPiracyPermission;

export const getAllIncidentsTableHasExportPiracyPermission = state =>
  state.response
    ? state.response.status === HttpStatus.NO_CONTENT.value
    : false;
